<!-------------searching---------------->
<div class="row mb-2 ">
<div class="col-sm-6">
<div class="input-group Top SearchSize">
    <input type="search" class="form-control form-control-lg " placeholder="search customer" id="search" name="search" [(ngModel)]="search" (ngModelChange)="Search();">
    <div class="input-group-append">
    <button type="submit" class="btn btn-lg btn-default" (click)="Search();">
    <i class="fa fa-search"></i>
    </button>
    </div>
    </div>
</div>
<div class="col-sm-6">
    <div class="input-group Top SearchSize">
        <input type="search" class="form-control form-control-lg " placeholder="search emplyee" id="search" name="search" [(ngModel)]="employee" (ngModelChange)="Search_Employee();">
        <div class="input-group-append">
        <button type="submit" class="btn btn-lg btn-default" (click)="Search_Employee();">
        <i class="fa fa-search"></i>
        </button>
        </div>
        </div>
</div>
</div>  
<!------------------------------------------------------->

<section class="content-header ">
    
<div class="row mb-2 ">
<div class="col-sm-6">
<h1>Customer Approvals</h1>
</div>
</div>
</section>
<!--------------loader-------------------------->
<div *ngIf=loaderShown class="loader"></div>
<!----------------------------------------------->

<section class="content">
    
    <div class="card" *ngIf=CardShown>
    <div class="card-header">
    
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width:20%">
    Customer Name
    </th>

    <th style="width:28%">
    Employee Name
    </th>

    <th style="width:15%">
    Date
    </th>

    <th style="width: 8%">
    Location
    </th>

    <th style="width: 8%">
    Status
    </th>
    
     
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of CustomerApp">
    <td>
    {{c.customer_name}}
    </td>

    <td>
    {{c.employee_name}}
    </td>

    <td>
    {{DateFormat(c.date_time)}}
    </td>
        
    
    <td>
    <a class=" btn-sm edit_style space"  data-toggle="modal" data-target="#modal-sm">
    <mat-icon (click)="FindLocation(c.customer_latitude,c.customer_longitude);">room</mat-icon>
   </a>
    </td>

    <td>
    {{c.status}}
    </td>
    
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)="Approve(c.customer_id,c._id,c.customer_latitude,c.customer_longitude);">
    <i class="fas fa-award">
    </i>
    Approve
    </a>
    <!----
    <a class="btn btn-info btn-sm left" (click)='getValue(c.brand_id);EditBrands()'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    -->
    <a class="btn btn-danger btn-sm left"(click)="Reject(c.customer_id,c._id,c.customer_latitude,c.customer_longitude);">
    <i class="fas fa-trash">
    </i>
    Reject
    </a>
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!---------------------paging------------------------------------->
<ul class="pagination" *ngIf=CardShown>
    <li class="paginate_button page-item previous" id="example2_previous">
    <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
    
    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
               
    <li class="paginate_button page-item next" id="example2_next" >
    <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
    </ul>
<!-----------pop up------------------------------------------------>
<div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
    <div class="modal-content top">
    
    <div class="modal-body">
    
        <google-map height="400px" width="100%"  [center]="center"  [zoom]="zoom">
            <map-marker
              *ngFor="let marker of markers"
              [position]="marker.position"
              [label]="marker.label"
              [title]="marker.title"
              [options]="marker.options"
            >
            </map-marker>
          </google-map>

    </div>
    <div class="modal-footer center1">

        <label>Latitude: {{map_lat}}</label>
        <label class="lab">Longitude: {{map_log}}</label>
    <!----
    <button type="button" class="btn btn-default" data-dismiss="modal">ok</button>
    --->
    </div>
   
    </div>

  


